import {nombreDeAcciones}  from './nombreDeAcciones';
import {functions} from './functions';

export const NOMBRE_DE_SISTEMA = process.env.REACT_APP_SECRET_NAME;
export const API_BACKEND_URL =process.env.REACT_APP_API_BACKEND;
export const API_SSO_URL =process.env.REACT_APP_API_SSO;

export const TOKEN_DE_ACCESO = 'accessToken';

export {nombreDeAcciones};
export {functions};

export const publicMenu = [];